import {
  spineForCategory,
  spineForJournal,
} from "@/src/components/common/broadsheet/tokens";
import { stripHTMLTags } from "@/src/utils/strip-html-tags";
import { truncateAtWord } from "@/src/utils/textTransform";
import { cdnServeUrl, journalBaseHref } from "@/src/utils/paths";

export const journalHref = (journal: any) =>
  journalBaseHref(journal) ?? "/journal-finder";

export const journalBlurb = (journal: any, length = 110) =>
  truncateAtWord(stripHTMLTags(journal?.meta_data?.description), length);

export const coverSrc = (journal: any) =>
  cdnServeUrl(journal?.meta_data?.default_cover_image_thumbnail);

export const journalMetrics = (journal: any) => {
  const meta = journal?.meta_data ?? {};
  return {
    citeScore: meta.citation_score ? String(meta.citation_score) : null,
    jif: meta.if_score ? String(meta.if_score) : null,
    decision: meta.time_to_first_decision
      ? String(meta.time_to_first_decision)
      : null,
    acceptance: meta.acceptance_rate ? String(meta.acceptance_rate) : null,
    frequency: meta.frequency ? String(meta.frequency) : null,
    abbr: meta.nlm_ta ? String(meta.nlm_ta) : null,
    field: journal?.categories?.[0] ?? null,
  };
};

export const groupByCategory = (journals: any[]) => {
  const groups = new Map<string, any[]>();

  journals.forEach((journal) => {
    const fields: string[] = journal.categories?.length
      ? journal.categories
      : ["Other"];
    fields.forEach((field: string) => {
      const key = field?.trim() || "Other";
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key)!.push(journal);
    });
  });

  return [...groups.entries()].sort((a, b) => a[0].localeCompare(b[0]));
};

export const byTitle = (a: any, b: any) =>
  String(a.title).localeCompare(String(b.title));

export { spineForCategory, spineForJournal };

export const FEATURED_COUNT = 3;

export const pickFeaturedIds = (
  journals: any[],
  count = FEATURED_COUNT,
): number[] => {
  const withCovers = journals.filter(
    (journal) => journal?.meta_data?.default_cover_image_thumbnail,
  );
  const pool = withCovers.length >= count ? withCovers : journals;
  const shuffled = [...pool];

  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled.slice(0, count).map((journal) => journal.id);
};
